import React from 'react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import { SubHeading } from '../../components';
import { data } from '../../constants';

import './Experience.css';
import 'react-vertical-timeline-component/style.min.css'

const ExperienceCard = ({ experience }) => {
    return (
        <VerticalTimelineElement
            contentStyle={{ background: '#45a29e' }}
            contentArrowStyle={{ borderRight: '7px solid #45a29e' }}
            date={experience.date}
            dateClassName='app__experience-elementCard_date'
            iconStyle={{ background: '#45a29e' }}
            icon={
                <div>
                    <a href={experience.company_website} target="_blank" rel="noopener noreferrer">
                    <img
                    src={experience.icon}
                    alt={experience.company_name}
                    className='app__Experience-company_icon'/>
                    </a>
                </div>
            }
        >
            <div className='app__experience-elementCard_title'>
                <h1>{experience.title}</h1>
                <div className='app__experience-elementCard_company_name'>{experience.company_name}</div>
                <div className='app__experience-elementCard_location'>{experience.location}</div>
            </div>

            <ul className='app__experience-elementCard_job'>
                {experience.points.map((point, index) => (
                    <li key={'experience-point-${index}'} className='app__experience-elementCard_jobPoints'>
                        {point}
                    </li>
                ))}
            </ul>
        </VerticalTimelineElement>
    )
}

const Experience = () => {
    return (
        <div className='app__experience flex__center section__padding' id='experience'>
            <div className='app__Experience-title'>
                <h1 className='headtext__cormorant'>Career History</h1>
            </div>

            <div className='app__experience-element'>
                <VerticalTimeline
                    lineColor='#45a29e'>
                    {data.wines.map((wine, index) => (
                        <ExperienceCard key={wine.title + index} experience={wine} />
                    ))}
                </VerticalTimeline>
            </div>
        </div>
    )
}

export default Experience